import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { format } from "date-fns";

export interface AvailableSlot {
  slot_start: string;
  slot_end: string;
  is_available: boolean;
  blocked_reason: string | null;
}

export const useDoctorAvailableSlots = (
  doctorId?: string,
  clinicId?: string,
  date?: Date,
  slotMinutes: number = 30
) => {
  return useQuery({
    queryKey: ["doctor-available-slots", doctorId, clinicId, date?.toISOString(), slotMinutes],
    queryFn: async () => {
      if (!doctorId || !clinicId || !date) return [];

      const { data, error } = await supabase.rpc("get_doctor_all_slots", {
        p_doctor_id: doctorId,
        p_clinic_id: clinicId,
        p_date: format(date, "yyyy-MM-dd"),
        p_slot_minutes: slotMinutes,
      });

      if (error) throw error;
      return (data || []) as AvailableSlot[];
    },
    enabled: !!doctorId && !!clinicId && !!date,
  });
};
